import type {IResourcesUsageData} from "@torim-app/types";
import {AnalyticsApi} from "@app/api/admin";
import {computed, reactive} from "vue";

export const useResourceUsage = () => {
  const usageData = reactive<IResourcesUsageData>(<IResourcesUsageData>{});

  const getResourcesUsageData = async () => {
    const usageDataResponse = await AnalyticsApi.fetchResourcesUsage();
    Object.assign(usageData, usageDataResponse)
  }

  const smsUsage = computed(() => (usageData?.sms?.used && usageData?.sms?.limit)
    ? usageData.sms.used / usageData.sms.limit : 0);
  const whatsappUsage = computed(() => (usageData?.whatsapp?.used && usageData?.whatsapp?.limit)
    ? usageData.whatsapp.used / usageData.whatsapp.limit : 0);
  const appointmentsUsage = computed(() => (usageData?.appointments?.used && usageData?.appointments?.limit)
    ? usageData.appointments.used / usageData.appointments.limit : 0);

  return {
    smsUsage, whatsappUsage, usageData, appointmentsUsage,
    getResourcesUsageData
  }
}
